/** Remove a supported locale segment before comparing navigation paths. */
export function stripNavigationLocalePrefix(pathname = "") {
  return pathname.replace(/^\/(es|fr-CA)(?=\/|$)/, "");
}

/** Accept both browser-style hashes and the fragment-only form used by state. */
function stripHashPrefix(hash = "") {
  return hash.startsWith("#") ? hash.slice(1) : hash;
}

/** Return whether a menu href matches the current path and, when set, hash. */
export function isNavItemActive(pathname, href, currentHash = "") {
  if (!href) return false;

  const normalizedPathname = stripNavigationLocalePrefix(pathname || "");
  const normalizedHref = stripNavigationLocalePrefix(href);
  const [targetPath, targetHash = ""] = normalizedHref.split("#", 2);

  if (normalizedPathname !== targetPath) return false;
  if (!targetHash) return true;

  return stripHashPrefix(currentHash) === targetHash;
}
